import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { User,Proffesional, Specialty, Language } from '../model/dto';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseModel } from '../model/base.model';
import { UserModel } from '../model/user.model';
import * as $ from 'jquery';

@Component({
  selector: 'app-pro-detail',
  templateUrl: './pro-detail.component.html',
  styleUrls: ['./pro-detail.component.css'],
  inputs: ['action']
})
export class ProDetailComponent implements OnInit {

subscription:any;
public proffesional:Proffesional = new Proffesional(0,0,'','','',[],[],'',0,0,'','','','','','','','','','', '','',new User(0,0,'','','','',''));
public years:number = 0;
public specialties:Specialty[];
public specialtyNames:string = '';
public selSpecialties:Specialty[] = [];
public user:User;
public status:string;
public hideProfile:boolean = false;
public isMobile:boolean = false;
public daysSelected:string[] = [];
public canEdit:boolean = false;
public lang:string;
protected languages:Language[];

 constructor(private _api:ApiService, private route:ActivatedRoute, 
    private router:Router, private _baseModel:BaseModel, private _userModel:UserModel) { 
   this.user = this._userModel.user;
 	 this._api.getSpecialties()
      .subscribe(result => this.onSpecialties(result)); 
   this._api.getLanguages()
      .subscribe(result => this.onLanguages(result)); 
 }
  
  ngOnInit() {
    this.isMobile = ($(window).width()<600)
  	this.subscription = this.route.params.subscribe(params => {
         var id:number = parseInt(params['id']);
         if(!isNaN(id))
           this._api.getProfessional(id).subscribe(result => this.onProffesional(result));
       });
  }

  onSpecialties(data:object){
     this.specialties = data as Specialty[];
  }

  onLanguages(data:object){
    this.languages = data as Language[];
  }

  onProffesional(data:object){
   	var today = new Date();
   	var spec:Specialty;
    this.proffesional = data[0] as Proffesional;
    //Admin can edit and DSGO can edit his members
    var isDSGO = (this.user.PkUser == 73)
    var isAdmin = (this.user.email=='admin@admin.com')
    this.canEdit = (isAdmin || (isDSGO && this.proffesional.FkInstitution==1))

    if(data[0]['deleted_at']) this.hideProfile = true;
    if(this.proffesional['Days']){
      var days = this.proffesional['Days'].split(',')
      var d:string;
      for (var i = 0; i < days.length; i++) {
        if(days[i]=='m') d = 'Mon';
        if(days[i]=='t') d = 'Tue';
        if(days[i]=='w') d = 'Wed';
        if(days[i]=='th') d = 'Thu';
        if(days[i]=='f') d = 'Fri';
        if(days[i]=='s') d = 'Sat';
        this.daysSelected.push(d)
      }  
    }
    
    for (var i = 0; i < this.proffesional.specialty.length; i++) {
    	spec = this.proffesional.specialty[i];
    	spec.PkSpecialty = this.proffesional.specialty[i]['FkSpecialty'];
    	if(this.specialties) spec.Name = this.specialties.filter(item => item['PkSpecialty'] ==spec.PkSpecialty)[0]['Name'];
   		this.selSpecialties.push(spec)
    }
    this.lang = ''; var sel:Language;
    for (i = 0; i < this.proffesional.language.length; i++) {
      sel = this.languages.filter(item => item['PkLanguage'] == this.proffesional.language[i]['FkLanguage'])[0];
      this.lang +=sel.Name+','
    }
    this.lang = this.lang.substr(0, this.lang.length-1);
    this.years = today.getFullYear() - this.proffesional.Experience
    if(this.proffesional.Image && this.proffesional.Image.length>4)
    this._api.fileExists(this._api.domain+'images/proffesionals/'+this.proffesional.Image)
    	.subscribe(result=>this.showImage(result));
    if(this.proffesional.Pdf && this.proffesional.Pdf.length>4)
   	 this._api.fileExists(this._api.domain+'images/cvs/'+this.proffesional.Pdf)
    	.subscribe(result=>this.showPdf(result));
   
  }
  showImage(data){
  	if(data!=0) this.proffesional.Image = this._api.domain+'images/proffesionals/'+this.proffesional.Image;
  	else  this.proffesional.Image = null;
   
  }
  showPdf(data){
  	if(data!=0) this.proffesional.Pdf = this._api.domain+'images/cvs/'+this.proffesional.Pdf
  	else  this.proffesional.Pdf = null;
  }

  handleAction(evt){
    
    if(evt.name=='message'){
      var tmp = evt.value.split('|')
      //console.log('PkUser '+this.proffesional.user.PkUser)
      this._api.sendMessage(this.user.PkUser, this.proffesional.user.PkUser, tmp[0], tmp[1])
          .subscribe(result=>this.onMessage(result));
    }
    if(evt.name=='saveToMyList'){
        this._api.addToMyList( this.proffesional.user.PkUser, this.user.PkUser)
          .subscribe(result=>this.onList(result));
    }
  }

  onMessage(data:object){
    this.status = "Message sended to "+this.proffesional.FirstName+" "+this.proffesional.LastName;
     window['closeModal']('msg', 'show');
  }
  onList(data:object){
    if(data['success']==true){
      this.status = this.proffesional.FirstName+" "+this.proffesional.LastName+" was added to your list";
    }  else this.status = 'This proffesional is already in your list'
    window['closeModal']('confirma', 'show');
  }
}
